import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import ClearAll from '@material-ui/icons/ClearAll';
import OutlinedTextField from '../../OutlinedTextField';
import {
    getTextFieldChangedValue, getTextFieldValueByNativeEvent,
    isEnterKeyPressed, isGroupSeparatorPressed,
    isValidFunction,
    isValidText,
} from '../../../constants/CommonUtil';
import { getProductDetailsFromScannedBarcode } from './InternalMovesUtil';
import { GROUP_SEPARATOR_CHAR } from '../../../constants/constants';
import Mousetrap from '../../../constants/mousetrap';
import { isObjectValidAndNotEmpty } from '../../../constants/nullCheckUtils';

class DrugBarcodeEntry extends React.Component {
    constructor(props) {
        super(props);
        this.barcodeRef = React.createRef();
        this.state = {
            enterBarcodeProductQty: false,
            scannedBarcode: '',
            barcodeProductQty: '',
        };
    }
    componentDidMount() {
        const { enabledShortcut } = this.props;
        if (isValidText(enabledShortcut) && isValidFunction(this.barcodeRef.current.focus)) {
            Mousetrap.bindGlobal(enabledShortcut, () => {
                this.barcodeRef.current.focus();
            });
        }
    }

    componentWillUnmount() {
        const { enabledShortcut } = this.props;
        if (isValidText(enabledShortcut)) {
            Mousetrap.unbind(enabledShortcut);
        }
    }

    onChangeScannedBarcode = (_, event) => {
        const changedVal = getTextFieldValueByNativeEvent(event);
        this.setState({
            scannedBarcode: changedVal,
        });
    };

    onChangeBarcodeProductQty = (e) => {
        const changedVal = getTextFieldChangedValue(e);
        this.setState({
            barcodeProductQty: changedVal,
        });
    };

    onKeyDown = async (e) => {
        const { scannedBarcode } = this.state;
        if (isEnterKeyPressed(e)) {
            // check if the barcode scanned has the product in this list
            const {
                dispatch,
                onlyBatch,
                barcodeParser,
            } = this.props;
            const prodInfo = await getProductDetailsFromScannedBarcode(scannedBarcode, dispatch, onlyBatch, barcodeParser);
            if (isObjectValidAndNotEmpty(prodInfo) && prodInfo.produceCode) {
                this.setState({
                    enterBarcodeProductQty: true,
                });
            }
        }
        if (isGroupSeparatorPressed(e)) {
            this.setState({
                scannedBarcode: scannedBarcode + GROUP_SEPARATOR_CHAR,
            });
        }
    };

    onBarcodeProductQtyConfirm = async (e) => {
        if (isEnterKeyPressed(e)) {
            const {
                onConfirmQuantity,
                dispatch,
                barcodeParser,
            } = this.props;
            const {
                barcodeProductQty,
                scannedBarcode,
            } = this.state;
            const prodInfo = await getProductDetailsFromScannedBarcode(scannedBarcode, dispatch, false, barcodeParser);
            if (prodInfo) {
                const successfull = onConfirmQuantity(prodInfo, barcodeProductQty);
                if (successfull) {
                    this.clearBarcodeEntry();
                }
            }
        }
    };

    clearBarcodeEntry = () => {
        this.setState({
            enterBarcodeProductQty: false,
            barcodeProductQty: '',
            scannedBarcode: '',
        });
    };

    render() {
        const {
            barcodeProductQty,
            enterBarcodeProductQty,
            scannedBarcode,
        } = this.state;
        const {
            onConfirmQuantity,
            disableAutoFocus,
        } = this.props;
        console.log(onConfirmQuantity, barcodeProductQty);
        return (
            <Grid container className={!disableAutoFocus ? 'mt-1' : null} spacing={16}>
                <Grid item sm={4} md={4} lg={4}>
                    <OutlinedTextField
                        key={enterBarcodeProductQty}
                        label="Scan barcode"
                        inputRef={this.barcodeRef}
                        value={scannedBarcode}
                        disabled={enterBarcodeProductQty}
                        onChange={this.onChangeScannedBarcode}
                        onKeyDown={this.onKeyDown}
                        autoFocus={!disableAutoFocus}
                    />
                </Grid>
                {
                    enterBarcodeProductQty &&
                    <React.Fragment>
                        <Grid item sm={3} md={3} lg={3}>
                            <OutlinedTextField
                                label="Quantity"
                                value={barcodeProductQty}
                                onChange={this.onChangeBarcodeProductQty}
                                onKeyDown={this.onBarcodeProductQtyConfirm}
                                type="number"
                                autoFocus
                            />
                        </Grid>
                        <Grid item sm={2} md={2} lg={2}>
                            <IconButton onClick={this.clearBarcodeEntry}>
                                <ClearAll />
                            </IconButton>
                        </Grid>
                    </React.Fragment>
                }
            </Grid>
        );
    }
}

DrugBarcodeEntry.propTypes = {
    dispatch: PropTypes.func,
    onConfirmQuantity: PropTypes.func,
    onlyBatch: PropTypes.bool,
    barcodeParser: PropTypes.string,
    disableAutoFocus: PropTypes.bool,
    enabledShortcut: PropTypes.string,
};

DrugBarcodeEntry.defaultProps = {
    dispatch: () => {},
    onConfirmQuantity: () => {},
    onlyBatch: false,
    barcodeParser: '',
    disableAutoFocus: false,
    enabledShortcut: '',
};

export default DrugBarcodeEntry;

